export default "__VITE_ASSET__B6fur2qa__"